// extracted by mini-css-extract-plugin
export default {"curtain":"styles_curtain__HqN0U","skillContainer":"styles_skillContainer__65XZC","lineChildren":"styles_lineChildren__qAgOk"};